import React, { useState } from "react";
import onClickOutside from "react-onclickoutside";
import styled from "@emotion/styled";

const Avatar = styled.img`
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-right: 8px;
`;

const Name = styled.span`
  font-size: 0.9em;
  font-weight: 600;
  color: #505050;
  display: inline-block;
  vertical-align: middle;
  word-break: keep-all;
  white-space: nowrap;
`;

const SubMenu = styled.div`
  position: absolute;
  top: 125%;
  right: 0;
  background: #fff;
  box-shadow: 0 1px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  min-width: 10em;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
`;

const SubMenuItem = styled.li`
  line-height: 1;

  span {
    display: block;
    text-align: left;
    padding: 0.9em 20px;
    color: #505050;

    cursor: pointer;
    font-size: 0.9em;
    line-height: 1;

    &:hover {
      background: #f2f2f2;
      color: #363636;
    }
  }
`;
const MenuTrigger = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  background-color: transparent;
`;
type IdeasNavBarDissmissable = { (props: IdeasNavbarUserProps): JSX.Element; handleClickOutside: () => void };

type IdeasNavbarUserProps = {
  user: { avatarURL: string; title: string; lastName: string } | undefined;
  logout: () => void;
};
const IdeasNavbarUser = (({ user, logout }: IdeasNavbarUserProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  IdeasNavbarUser.handleClickOutside = () => setShowDropdown(false);

  return (
    <MenuTrigger
      onClick={() => setShowDropdown(!showDropdown)}
      aria-label="Click this button to open the user menu"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded={showDropdown}
    >
      <Avatar src={user?.avatarURL ?? ""} />
      <Name>
        {user?.title ?? ""} {user?.lastName ?? ""}
      </Name>
      {showDropdown && (
        <SubMenu>
          <ul role="menu">
            <SubMenuItem>
              <span role="menuitem" tabIndex={0} onClick={() => logout()} onKeyDown={() => logout()}>
                Logout
              </span>
            </SubMenuItem>
          </ul>
        </SubMenu>
      )}
    </MenuTrigger>
  );
}) as IdeasNavBarDissmissable;

const clickOutsideConfig = {
  handleClickOutside: () => IdeasNavbarUser.handleClickOutside,
};

export default onClickOutside(IdeasNavbarUser, clickOutsideConfig);
